import { addMinutes } from 'date-fns';
import { useCallback } from 'react';
import { useGetStartDateTime } from '../../../components';
import type { CreateEventData } from '../../../queries';
import type { CreateEventFormValues } from '../CreateEventForm';

export const useCreateFormRequestData = () => {
  const getStartDateTime = useGetStartDateTime();

  return useCallback(
    (formValues: CreateEventFormValues): CreateEventData => {
      const startTime = getStartDateTime({ startDate: formValues.startDate, startTime: formValues.startTime });
      const endTime = addMinutes(startTime, formValues.duration);

      return {
        channel: {
          featuredInChannels: formValues.featuredInChannels,
          organization: formValues.organization?.value,
          showInChannel: formValues.showInChannels,
          tags: formValues.tags,
        },
        distributionList: formValues.invitations
          ?.filter((invitation) => invitation.type === 'community')
          .map((invitation) => ({
            communityId: invitation.value,
            communityName: invitation.label,
          })),
        endTime: endTime.toISOString(),
        html: formValues.htmlDescription,
        name: formValues.name,
        participants:
          formValues.invitations
            ?.filter((invitation) => invitation.type !== 'community')
            .map((invitation) =>
              invitation.type === 'email'
                ? { email: invitation.value, role: invitation.role, type: 'email' }
                : { ref: invitation.value, role: invitation.role, type: 'user' },
            ) ?? [],
        startTime: startTime.toISOString(),
        text: formValues.textDescription,
        type: formValues.type,
      };
    },
    [getStartDateTime],
  );
};
